import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useFormik } from 'formik';
import { useAuth } from '../../context/AuthContext';
import server from '../../../../global/server';
import useHandleErrors from '../../../../hooks/useHandleErrors';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';

const Login = props => {
    const { verifySession, setUser, token } = useAuth();
    const navigation = useNavigate();
    const {enqueueSnackbar} = useSnackbar()

    const [hasError, setError] = useState();
    useHandleErrors(hasError);

    const { values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting } = useFormik({
        initialValues: { document: '', password: '' },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                await server.post('auth/firstUser');
                const { data } = await server.post('auth', values);
                sessionStorage.setItem('token', data.data.token);
                sessionStorage.setItem('user', JSON.stringify(data.data.user));
                setUser(data.user);
                verifySession();
                setSubmitting(false);
                navigation('/dashboard');
            } catch (error) {
                setSubmitting(false);
                setError(error);
            }
        },
    });

    useEffect(() => {
        console.log(token)
        if (token) {
            navigation('/dashboard');
        }
    }, [token]);

    return (
        <PanelAuth>
            <div>
                {/* <Logo>
                    <img width={250} src={logo}sx={{ marginBottom: 20 }} />
                </Logo> */}
                <BoxAuth>
                    <form onSubmit={handleSubmit}>
                        <Grid container direction="column" gap={2}>
                            <Grid>
                                <Title>
                                    <Typography variant="h6">Faça o login</Typography>
                                </Title>
                            </Grid>
                            <Grid>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    required
                                    label="Documento (CPF)"
                                    type="text"
                                    name="document"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.document}
                                    error={errors.document}
                                    helperText={errors.document}
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    label="Senha"
                                    type="password"
                                    name="password"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.password}
                                    error={errors.password}
                                    helperText={errors.password}
                                />
                            </Grid>

                            <Grid>
                                <LoadingButton
                                    type="submit"
                                    fullWidth
                                    loading={isSubmitting}
                                    variant="contained"
                                    disabled={!(values.document && values.password) || isSubmitting}
                                >
                                    Entrar
                                </LoadingButton>
                            </Grid>
                            {/* <Grid>
                                <LoadingButton onClick={() => navigation('/profile/login')} fullWidth variant="text" disabled={isSubmitting}>
                                    Acesso profissional
                                </LoadingButton>
                            </Grid>
                            <Grid>
                                <LoadingButton onClick={() => navigation('/profile/register')} fullWidth variant="text" disabled={isSubmitting}>
                                    Criar curriculo
                                </LoadingButton>
                            </Grid> */}
                        </Grid>
                    </form>
                </BoxAuth>
            </div>
        </PanelAuth>
    );
};

export default Login;

const PanelAuth = styled.div`
    width: 100%;
    height: 100%;
    display: flexbox;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #eee;
`;

const BoxAuth = styled(Grid)`
    border: 1px solid #ccc;
    border-radius: 1rem;
    padding: 2rem;
    width: 350px;
    background: white;
`;

const Title = styled.div`
    text-align: center;
    margin-bottom: 20px;
`;

const BoxAuthContainer = styled.div`
    padding: 1px;
`;
